/*jshint esversion: 6 */
// warning: vue is in dev mode

const holidayStrings = [
    "January 1, 2021", "January 18, 2021", "May 31, 2021", "July 4, 2021", "September 6, 2021", "November 25, 2021"
];
const holidays = [{ weekdays: [1, 7] }];
const holidaysWeekends = [];
holidayStrings.forEach((day) => {
    let d = new Date();
    d.setTime(Date.parse(day));
  	holidaysWeekends.push(d);
    holidays.push(d);
});


const store = new Vuex.Store({
    state: {
        all_items: [],
        insuranceOptions: [],
        first_leg: {
            leg_name: "First Leg",
            pickup: {
                date: null,
                locationIndex: null,
                city: null,
                customAddress: null,
                customCity: null,
                customState: null,
                customZip: null,
                customName: null, 
              customApt: null
            },
            dropoff: {
                date: null,
                locationIndex: null,
                city: null,
                customAddress: null,
                customCity: null,
                customState: null,
                customZip: null,
                customName: null,
              customApt: null
            },
        },
        second_leg: {
            leg_name: "Second Leg",
            pickup: {
                date: null,
                locationIndex: null,
                city: null,
                customAddress: null,
                customCity: null,
                customState: null,
                customZip: null,
                customName: null,
              customApt: null
            },
            dropoff: {
                date: null,
                locationIndex: null,
                city: null,
                customAddress: null,
                customCity: null,
                customState: null,
                customZip: null,
                customName: null,
              customApt: null
            },
        },
        items: {},
        screen: "first_leg",
        roundtrip: false,
        insuranceValue: 0,
        insurancePrice: 0,
        insuranceID: 41129354002629,
        totalPrice: 0,
        itemCount: 0,
    },
    mutations: {
        setUpItems(state, items) {
            state.all_items = items;
        },
        setUpInsurance(state, insurance) {
            state.insuranceOptions = insurance.sort((a, b) => a.price - b.price);
        },
        setDate(state, { leg, waypoint, date }) {
            state[leg][waypoint].date = date;
        },
        setCity(state, { leg, waypoint, city }) {
            state[leg][waypoint].city = city;
            state[leg][waypoint].customCity = city;
            if (city !== "custom" && state[leg][waypoint].locationIndex !== "custom") {
                state[leg][waypoint].customAddress = null;
            }
        },
        setLocationIndex(state, { leg, waypoint, locationIndex }) {
            state[leg][waypoint].locationIndex = locationIndex;
            if (locationIndex !== "custom" && state[leg][waypoint].city !== "custom") {
                state[leg][waypoint].customAddress = null;
            }
        },
        setCustomAddress(state, { leg, waypoint, customAddress }) {
            state[leg][waypoint].customAddress = customAddress;
            if (customAddress) {
                state[leg][waypoint].locationIndex = "custom";
            }
        },
        setCustomCity(state, { leg, waypoint, customCity }) {
            state[leg][waypoint].customCity = customCity;
        },
        setCustomState(state, { leg, waypoint, customState }) {
            state[leg][waypoint].customState = customState;
        },
        setCustomZip(state, { leg, waypoint, customZip }) {
            state[leg][waypoint].customZip = customZip;
        },
        setCustomName(state, { leg, waypoint, customName }) {
            state[leg][waypoint].customName = customName;
        },
      setCustomApt(state, { leg, waypoint, customApt }) {
    state[leg][waypoint].customApt = customApt;
  },
        updateItems(state, { item_id, quantity }) {
            state.items[String(item_id)] = parseInt(quantity);
            let item_count = 0;
            for (const [name, q] of Object.entries(state.items)) {
                item_count += parseInt(q);
            }
            state.itemCount = item_count;
        },
        changeScreen(state, screen) {
            state.screen = screen;
        },
        changeRT(state, bool) {
            state.roundtrip = bool;
        },
        changePrice(state, price) {
            state.totalPrice = price;
        },
        updateInsurance(state, id) {
            if (id === "0") {
                state.insurancePrice = 0;
                state.insuranceValue = 0;
                state.insuranceID = id;
            } else {
                let ins = state.insuranceOptions.find(item => item.id === id);
                state.insurancePrice = ins.price / 100;
                state.insuranceValue = parseInt(ins.title.replace('$', ''));
                state.insuranceID = id;
            }
        }
    },
    actions: {
        updateItems({ dispatch, commit }, { item_id, quantity }) {
            commit('updateItems', { item_id, quantity });
            dispatch('updatePrice');
        },
        updatePrice({ commit, state }) {
            let price = 0;
            for (const [id, q] of Object.entries(state.items)) {
                let item = state.all_items.filter(_item => String(_item.id) === String(id))[0];
                price += q * (state.roundtrip ? item.price * 2 : item.price) / 100;
            }
            price += state.insurancePrice * (state.roundtrip ? 2 : 1);
            commit('changePrice', price);
        },
        updateInsurance({ dispatch, commit }, id) {
            commit('updateInsurance', id);
            dispatch('updatePrice');
        },
        changeRT({ dispatch, commit }, bool) {
            commit('changeRT', bool);
            dispatch('updatePrice');
        }
    }
});


// DATEPICKER
Vue.component('datepicker', {
    props: {
        leg: {
            type: String,
            required: true
        },
        waypoint: {
            type: String,
            required: true
        }
    },
    data: function () {
      return {
        holidays: this.waypoint === 'pickup' ? holidays : holidaysWeekends
      };
    },
    template: `
    <v-date-picker
      v-model="date"
      class="datepicker"
      :popover="{ placement: 'bottom', visibility: 'click'}"
      :input-props='{
        placeholder: "Select a date",
        readonly: true
      }'
      :min-date="earliestDate"
      :disabled-dates=holidays>
    </v-date-picker>`,
    methods: {
        isBusinessDay(date) {
            const isWeekend = date.getDay() === 0 || date.getDay() === 6;
            const isHoliday = holidays.some(h => h instanceof Date && h.toDateString() === date.toDateString());
            return !isWeekend && !isHoliday;
        },
        getNextBusinessDay(date) {
            let result = new Date(date);
            while (!this.isBusinessDay(result)) {
                result.setDate(result.getDate() + 1);
            }
            return result;
        },
        addBusinessDays(startDate, numDays) {
            let result = new Date(startDate);
            let added = 0;
            while (added < numDays) {
                result.setDate(result.getDate() + 1);
                if (this.isBusinessDay(result)) {
                    added++;
                }
            }
            return result;
        }
    },
    computed: {
        date: {
            get() {
                return this.$store.state[this.leg][this.waypoint].date;
            },
            set(value) {
                this.$store.commit('setDate', {
                    leg: this.leg,
                    waypoint: this.waypoint,
                    date: value
                });
            }
        },
        earliestDate() {
            const today = new Date();
            let tomorrow = new Date(today);
            tomorrow.setDate(today.getDate() + 1);
            tomorrow = this.getNextBusinessDay(tomorrow);

            const trip_details = this.$store.state;

            if (this.leg === "first_leg" && this.waypoint === "pickup") {
                return tomorrow;
            } else if (this.leg === "first_leg" && this.waypoint === "dropoff") {
                if (!trip_details.first_leg.pickup.date) return tomorrow;
                return this.addBusinessDays(new Date(trip_details.first_leg.pickup.date), 5);
            } else if (this.leg === "second_leg") {
                if (this.waypoint === "pickup") {
                    return trip_details.first_leg.dropoff.date || trip_details.first_leg.pickup.date || tomorrow;
                } else {
                    if (!trip_details.second_leg.pickup.date) {
                        return trip_details.first_leg.dropoff.date || trip_details.first_leg.pickup.date || tomorrow;
                    }
                    return this.addBusinessDays(new Date(trip_details.second_leg.pickup.date), 5);
                }
            }
            return tomorrow;
        }
    },
    watch: {
        earliestDate() {
            if (this.earliestDate > this.date) {
                this.date = null;
            }
        }
    }
});

// LOCATION
// UPDATED LOCATION COMPONENT (GOOGLE AUTOCOMPLETE)
Vue.component('location', {
  props: {
    leg: {
      type: String,
      required: true
    },
    waypoint: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      tmpCustomAddress: '',
      tmpCustomApt: '',
      tmpCustomCity: '',
      tmpCustomState: '',
      tmpCustomZip: '',
      tmpCustomName: '',
      showNameField: true,
      addressSelected: false
    };
  },
  mounted() {
    const wp = this.$store.state[this.leg][this.waypoint];

    // Initialize from store values
    this.tmpCustomAddress = wp.customAddress || '';
    this.tmpCustomApt = wp.customApt || '';
    this.tmpCustomCity = wp.customCity || '';
    this.tmpCustomState = wp.customState || '';
    this.tmpCustomZip = wp.customZip || '';
    this.tmpCustomName = wp.customName || '';

    if (wp.customAddress || wp.customCity || wp.customState || wp.customZip) {
      this.addressSelected = true;
    }

    // Pull fromName/toName from URL if present
    const params = new URLSearchParams(window.location.search);
    const fromName = params.get("fromName");
    const toName = params.get("toName");

    if (this.leg === 'first_leg' && this.waypoint === 'pickup' && fromName) {
      this.tmpCustomName = decodeURIComponent(fromName);
      this.$store.commit('setCustomName', { leg: this.leg, waypoint: this.waypoint, customName: this.tmpCustomName });
      this.showNameField = true;
    }
    if (this.leg === 'first_leg' && this.waypoint === 'dropoff' && toName) {
      this.tmpCustomName = decodeURIComponent(toName);
      this.$store.commit('setCustomName', { leg: this.leg, waypoint: this.waypoint, customName: this.tmpCustomName });
      this.showNameField = true;
    }

    // Google Maps Autocomplete setup
    if (window.google && window.google.maps) {
      const autocomplete = new google.maps.places.Autocomplete(this.$refs.autocomplete, {
        types: ['geocode', 'establishment'],
        componentRestrictions: { country: 'us' }
      });

      autocomplete.addListener('place_changed', () => {
        const place = autocomplete.getPlace();
        if (!place.address_components) return;

        const getComp = (type) =>
          place.address_components.find((c) => c.types.includes(type))?.long_name || '';

        const streetNumber = getComp('street_number');
        const route = getComp('route');
        const fullAddress = `${streetNumber} ${route}`.trim();

        this.tmpCustomAddress = fullAddress;
        this.tmpCustomCity = getComp('locality') || getComp('sublocality') || getComp('neighborhood');
        this.tmpCustomState = getComp('administrative_area_level_1');
        this.tmpCustomZip = getComp('postal_code');

        const placeName = place.name?.trim();
        const formattedAddress = place.formatted_address?.trim();

        const addressNormalized = formattedAddress?.toLowerCase().replace(/\s+/g, ' ').trim();
        const fullAddressNormalized = fullAddress.toLowerCase().replace(/\s+/g, ' ').trim();
        const nameNormalized = placeName?.toLowerCase().replace(/\s+/g, ' ').trim();

        const isNameInAddress =
          nameNormalized &&
          (addressNormalized?.includes(nameNormalized) || fullAddressNormalized.includes(nameNormalized));

        if (placeName && !isNameInAddress) {
          this.tmpCustomName = placeName;
          this.showNameField = true;
        } else {
          this.tmpCustomName = '';
          this.showNameField = true;
        }

        this.$store.commit('setCustomAddress', { leg: this.leg, waypoint: this.waypoint, customAddress: this.tmpCustomAddress });
        this.$store.commit('setCustomCity', { leg: this.leg, waypoint: this.waypoint, customCity: this.tmpCustomCity });
        this.$store.commit('setCustomState', { leg: this.leg, waypoint: this.waypoint, customState: this.tmpCustomState });
        this.$store.commit('setCustomZip', { leg: this.leg, waypoint: this.waypoint, customZip: this.tmpCustomZip });
        this.$store.commit('setCustomName', { leg: this.leg, waypoint: this.waypoint, customName: this.tmpCustomName });
        this.$store.commit('setCustomApt', { leg: this.leg, waypoint: this.waypoint, customApt: this.tmpCustomApt });
        this.$store.commit('setLocationIndex', { leg: this.leg, waypoint: this.waypoint, locationIndex: 'custom' });
        this.$store.commit('setCity', { leg: this.leg, waypoint: this.waypoint, city: this.tmpCustomCity });

        this.addressSelected = true;
      });
    }
  },
  computed: {
    customAddress: {
      get() {
        return this.$store.state[this.leg][this.waypoint].customAddress;
      },
      set(value) {
        this.$store.commit('setCustomAddress', { leg: this.leg, waypoint: this.waypoint, customAddress: value });
      }
    }
  },
  template: `
    <div class="custom-address" :class="{'address-visible': addressSelected}">
      <label>Enter Address</label>
      <input
        ref="autocomplete"
        type="text"
        placeholder="Start typing hotel name or address..."
        class="autocomplete-input"
        v-model="tmpCustomAddress"
        @blur="customAddress = tmpCustomAddress"
      />

      <div class="manual-fields">
        <div v-if="showNameField">
          <input
            type="text"
            placeholder="Hotel name (optional)"
            v-model="tmpCustomName"
            @blur="$store.commit('setCustomName', { leg: leg, waypoint: waypoint, customName: tmpCustomName })"
          />
        </div>
        <input placeholder="Street Address" type="text" v-model="tmpCustomAddress" @blur="$store.commit('setCustomAddress', { leg: leg, waypoint: waypoint, customAddress: tmpCustomAddress })" />
        <input placeholder="Apt, Suite, etc." type="text" v-model="tmpCustomApt" @blur="$store.commit('setCustomApt', { leg: leg, waypoint: waypoint, customApt: tmpCustomApt })" />
        <input placeholder="City" type="text" v-model="tmpCustomCity" @blur="$store.commit('setCustomCity', { leg: leg, waypoint: waypoint, customCity: tmpCustomCity })" />
        <input placeholder="State" type="text" v-model="tmpCustomState" @blur="$store.commit('setCustomState', { leg: leg, waypoint: waypoint, customState: tmpCustomState })" />
        <input placeholder="Zip" type="text" v-model="tmpCustomZip" @blur="$store.commit('setCustomZip', { leg: leg, waypoint: waypoint, customZip: tmpCustomZip })" />
      </div>
    </div>
  `
});




// WAYPOINT
Vue.component('waypoint', {
    props: {
        heading: {
            type: String,
        },
        subheading: {
            type: String
        },
        leg: {
            type: String,
            required: true
        },
        waypoint: {
            type: String,
            required: true
        }
    },
//   created: function() {
//     console.log(this.waypoint);
//   },
    template: `
<div class="waypoint">
    <span class="subheading">{{subheading}}</span>
    <span class="heading">{{heading}}</span>
    <location :leg=leg :waypoint=waypoint></location>
    <datepicker :leg=leg :waypoint=waypoint></datepicker>
    <div v-if="waypoint === 'dropoff'" class="express-quote" style="margin-top: 0.75rem; font-size: 0.95rem; color: #333;">
      Want your items at your destination faster?
      <a href="https://www.gotriphero.com/contact-ski-and-luggage-shipping" target="_blank" style="color: #007BFF; text-decoration: underline; margin-left: 0.25rem;">
        Request an express quote
      </a>
    </div>
</div>`
});

Vue.component('luggage', {
    data: function () {
        return {
            itemHeight: 67,
            showSizeInfo: false
        };
    },
    props: {
        heading: {
            type: String,
        },
        subheading: {
            type: String
        },
    },
    computed: {
        items() { return this.$store.state.all_items }
    },
    methods: {
        toggleSizeInfo() {
            this.showSizeInfo = !this.showSizeInfo;
        }
    },
    template: `
<div class="luggage">
    <span class="subheading">{{subheading}}</span>
    <span class="heading">{{heading}}</span>
    <div :style="{height: Math.ceil(items.length / 2) * itemHeight + 'px'}" class="luggage-items">
        <luggage-item 
            v-for="(item, i) in items" :item="item" 
            :key=i 
        />
    </div>

    <div class="bag-size-info" style="padding-top: 2rem;">
        <div class="toggle-size-info" @click="toggleSizeInfo" style="cursor: pointer; display: flex; align-items: center; gap: 6px;">
            <span>What size is my bag?</span>
            <span v-if="!showSizeInfo">&#9660;</span>
            <span v-else>&#9650;</span>
        </div>
        <div v-if="showSizeInfo" class="size-info-content" style="margin-top: 1rem;">
            <ul style="columns: 2; padding-left: 1rem;">
                <li><strong>Small Suitcase / Boot Bag:</strong> Up to 45 inches (L+W+H) and up to 25 lbs</li>
                <li><strong>Large Suitcase:</strong> Up to 59 inches (L+W+H) and up to 50 lbs</li>
                <li><strong>Oversize Suitcase:</strong> Up to 80 inches (L+W+H) and up to 75 lbs</li>
                <li><strong>Golf Bag Small:</strong> Up to 72 inches (L+W+H) and up to 30 lbs</li>
                <li><strong>Golf Bag Large:</strong> Up to 79 inches (L+W+H) and up to 50 lbs</li>
                <li><strong>Snowboard Bag Small:</strong> Up to 89 inches (L+W+H) and up to 30 lbs</li>
                <li><strong>Snowboard Bag Large:</strong> Up to 96 inches (L+W+H) and up to 40 lbs</li>
                <li><strong>Ski Bag Small:</strong> Up to 89 inches (L+W+H) and up to 30 lbs</li>
                <li><strong>Ski Bag Large:</strong> Up to 96 inches (L+W+H) and up to 40 lbs</li>
                <li><strong>Ski Bag Extra Large:</strong> Up to 101 inches (L+W+H) and up to 70 lbs</li>
            </ul>
        </div>

        <div class="missing-item" style="margin-top: 1.5rem; font-size: 0.95rem; color: #333;">
          Don't see your item listed?
          <a href="https://www.gotriphero.com/contact-ski-and-luggage-shipping" target="_blank" style="color: #007BFF; text-decoration: underline; margin-left: 0.5em;">
            Submit your details for a custom quote
          </a>
        </div>
    </div>
</div>
    `
});



// LUGGAGE-ITEM

Vue.component('luggage-item', {
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    data: function () {
        return {
            // q: 0,
        };
    },
    computed: {
        q: {
            get() {
                if (this.$store.state.items[String(this.item.id)] === undefined) return 0;
                return this.$store.state.items[String(this.item.id)];
            },
            set(value) {
                this.$store.dispatch('updateItems', {
                    item_id: this.item.id,
                    quantity: value,
                });
            }
        }
    },
    template: `
    <div class="luggage-item">
        <div class="luggage-item__content" style="display: flex; justify-content: space-between; align-items: center;">
            <span class="name">{{item.option1}}</span>
            <span class="price" style="margin-right: 10px; font-weight: bold;">\${{(item.price/100).toFixed(2)}}</span>
        </div>
        <div class="select-parent">
            <select class="q custom-select" v-model="q">
                <option v-for="i in 11">{{ i-1 }}</option>
            </select>
        </div>
    </div>
    `
});

// LEG-SUMMARY
Vue.component('leg-summary', {
    props: {
        leg: {
            type: String,
            required: true,
        }
    },
    computed: {
        screen() {
            return this.$store.state.screen;
        },
        show() {
            if (this.leg === 'first_leg' && this.screen !== 'first_leg') {
                return true;
            }
            return this.leg === 'second_leg' && this.screen === 'checkout' && this.$store.state.roundtrip;
        },
        pickup() {
            let data = this.$store.state[this.leg].pickup;
            let city = data.city === 'custom' ? data.customCity : data.city;
            return {city: city, date: data.date.toLocaleDateString('en-US')};
        },
        dropoff() {
            let data = this.$store.state[this.leg].dropoff;
          	let city = data.city === 'custom' ? data.customCity : data.city;
            return {city: city, date: data.date.toLocaleDateString('en-US')};
        },
        cleanLeg() {
            return this.leg.replace('_', ' ').replace(
                /\w\S*/g,
                function (txt) {
                    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                }
            );
        }

    },
    template: `
   <div class="summary" v-if="show" :class="leg" @click.prevent="$store.commit('changeScreen', leg)">
    <div class="leg align-middle">
        <h3>{{cleanLeg}}</h3>
        <span class="waypoints">
            <span class="waypoint_1">{{this.pickup.city}} ({{this.pickup.date}})</span>
            <span class="waypoint_2">{{this.dropoff.city}} ({{this.dropoff.date}})</span>
        </span>
    </div>
   </div>
   
   `
});

// INSURANCE
Vue.component('insurance', {
    computed: {
        insuranceAmount: {
            get() {
                return this.$store.state.insuranceID || 0;
            },
            set(value) {
                this.$store.dispatch('updateInsurance', value);
            }
        },
        roundtrip() {
            return this.$store.state.roundtrip;
        }
    },
    template: `
    
    <div class="insurance">
       <span class="heading">Insure Your Belongings</span>
        <p>
            Choose the amount of insurance required for coverage against loss, damage and theft, for all bags, per leg of your trip. 
        </p>
        
        <div class="select-parent">
            <select class="insurance-amount custom-select" v-model="insuranceAmount" v-if="$store.state.insuranceOptions">
                <option v-for="(insuranceOption, i) in $store.state.insuranceOptions" :value="insuranceOption.id">
					<template v-if="insuranceOption.title !== '$0'">
                    {{insuranceOption.title}} (+\${{(parseInt(insuranceOption.title.replace("$",""))/500 * 6.5 * Number(roundtrip ? 2:1)).toFixed(2)}})
					</template>
					<template v-else>
					{{insuranceOption.title}}
					</template>
                </option>
            </select>
        </div>
    </div>
`
});

Vue.component('errors', {
    props: {
        errors: {
            type: Array,
            required: false
        }
    },
    template: `
    <p v-if="errors.length" class="errors">
        <b>Please correct the following error(s):</b>
        <ul>
            <ul>
                <li v-for="error in errors">{{ error }}</li>
            </ul>
        </ul>          
    </p>
    `
});

Vue.component('checkout-item', {
    props: {
        item_id: {
            type: String,
            required: true
        },
        q: {
            type: Number,
            required: true
        }
    },
    computed: {
        itemName() {
            let tmp_name = this.$store.state.all_items.filter(_item => String(_item.id) === String(this.item_id))[0].option1,
                box = tmp_name.toLowerCase().includes('box'),
                plural = this.q !== 1;
            if (plural) {
                if (box) {
                    return tmp_name + 'es';
                }
                return tmp_name + 's';
            }
            return tmp_name;
        }
    },
    template: `
<li>
    {{q}} {{itemName}}
</li>
    `
});

const app = new Vue({
    el: '#shippingForm',
    store,
    data: function () {
        return {
            errors: [],
            checkingOut: false,
            showCheckout: false
        };
    },
    computed: {
        currentScreen() { return this.$store.state.screen },
        pickup() { return this.$store.state[this.$store.state.screen].pickup },
        dropoff() { return this.$store.state[this.$store.state.screen].dropoff }
    },
    methods: {
        nextScreen(screen, rt) {
            this.errors = [];
            if (this.pickup.city === null || this.pickup.customAddress === null) this.errors.push("Please set a pickup address");
            if (this.pickup.date === null) this.errors.push("Please set a pickup date");
            if (this.dropoff.city === null || this.dropoff.customAddress === null) this.errors.push("Please set a dropoff address");
            if (this.dropoff.date === null) this.errors.push("Please set a dropoff date");
            if (this.$store.state.itemCount < 1) this.errors.push("Please pick some items");
            if (this.errors.length) return;
            this.errors = [];
            this.$store.commit('changeRT', rt);
          this.$store.dispatch('updatePrice');
            this.showCheckout = true;
        },
        getItemPrice(id) {
            let item = this.$store.state.all_items.find(_item => String(_item.id) === String(id));
            return item ? item.price : 0;
        },
        getItemName(id) {
            let item = this.$store.state.all_items.find(_item => String(_item.id) === String(id));
            return item ? item.option1 : '';
        },
     getItemSubtotalByLeg(id, q, leg) {
    const price = this.getItemPrice(id) / 100; // Convert cents to dollars
    if (this.$store.state.roundtrip && (leg === 'first_leg' || leg === 'second_leg')) {
        return (price * q ).toFixed(2);
    }
    return (price * q).toFixed(2);
},
  getInsuranceSubtotal() {
    return this.$store.state.insurancePrice;
  },
      extractStreet(address) {
            const parts = address.split(',');
            return parts[0] ? parts[0].trim() : '';
        },
        extractCity(address) {
            const parts = address.split(',');
            return parts[1] ? parts[1].trim() : '';
        },
        extractState(address) {
            const parts = address.split(',');
            return parts[2] ? parts[2].trim().split(' ')[0] : '';
        },
        extractZip(address) {
            const parts = address.split(',');
            const zipMatch = parts[2] ? parts[2].match(/\d{5}/) : null;
            return zipMatch ? zipMatch[0] : '';
        },
    prefillAddressFromURL() {
    const params = new URLSearchParams(window.location.search);
    const fromAddress = params.get("from");
    const toAddress = params.get("to");
    const fromName = params.get("from_name");
    const toName = params.get("to_name");

    if (fromAddress) {
        this.$store.commit("setCustomAddress", {
            leg: "first_leg",
            waypoint: "pickup",
            customAddress: this.extractStreet(fromAddress),
        });
        this.$store.commit("setCustomCity", {
            leg: "first_leg",
            waypoint: "pickup",
            customCity: this.extractCity(fromAddress),
        });
        this.$store.commit("setCustomState", {
            leg: "first_leg",
            waypoint: "pickup",
            customState: this.extractState(fromAddress),
        });
        this.$store.commit("setCustomZip", {
            leg: "first_leg",
            waypoint: "pickup",
            customZip: this.extractZip(fromAddress),
        });
        this.$store.commit("setCity", {
            leg: "first_leg",
            waypoint: "pickup",
            city: this.extractCity(fromAddress),
        });
        this.$store.commit("setLocationIndex", {
            leg: "first_leg",
            waypoint: "pickup",
            locationIndex: "custom",
        });

        if (fromName) {
            this.$store.commit("setCustomName", {
                leg: "first_leg",
                waypoint: "pickup",
                customName: fromName
            });
        }
    }

    if (toAddress) {
        this.$store.commit("setCustomAddress", {
            leg: "first_leg",
            waypoint: "dropoff",
            customAddress: this.extractStreet(toAddress),
        });
        this.$store.commit("setCustomCity", {
            leg: "first_leg",
            waypoint: "dropoff",
            customCity: this.extractCity(toAddress),
        });
        this.$store.commit("setCustomState", {
            leg: "first_leg",
            waypoint: "dropoff",
            customState: this.extractState(toAddress),
        });
        this.$store.commit("setCustomZip", {
            leg: "first_leg",
            waypoint: "dropoff",
            customZip: this.extractZip(toAddress),
        });
        this.$store.commit("setCity", {
            leg: "first_leg",
            waypoint: "dropoff",
            city: this.extractCity(toAddress),
        });
        this.$store.commit("setLocationIndex", {
            leg: "first_leg",
            waypoint: "dropoff",
            locationIndex: "custom",
        });

        if (toName) {
            this.$store.commit("setCustomName", {
                leg: "first_leg",
                waypoint: "dropoff",
                customName: toName
            });
        }
    }
},
             submit() {
            this.errors = [];

            const validateLeg = (leg, label) => {
                if (!leg.pickup.customAddress) this.errors.push(`${label} pickup address is required`);
                if (!leg.pickup.date) this.errors.push(`${label} pickup date is required`);
                if (!leg.dropoff.customAddress) this.errors.push(`${label} dropoff address is required`);
                if (!leg.dropoff.date) this.errors.push(`${label} dropoff date is required`);
            };

            validateLeg(this.$store.state.first_leg, "First leg");

            if (this.$store.state.roundtrip) {
                validateLeg(this.$store.state.second_leg, "Second leg");
            }

            if (this.$store.state.itemCount < 1) {
                this.errors.push("Please select at least one luggage item");
            }

            if (this.errors.length) return;

            this.checkingOut = true;
            let itemObjects = [], c = 0;
            for (let item in this.$store.state.items) {
                let first_leg = this.$store.state.first_leg,
                    second_leg = this.$store.state.roundtrip ? this.$store.state.second_leg : null;

                for (let leg of [first_leg, second_leg]) {
                    if (leg === null) continue;
                    let pickupAddress = {
                        address: leg.pickup.customAddress,
                        apt: leg.pickup.customApt || '',
                        country: 'US',
                        name: leg.pickup.customName || '',
                        state: leg.pickup.customState,
                        zip: leg.pickup.customZip
                    };

                    let dropoffAddress = {
                        address: leg.dropoff.customAddress,
                        apt: leg.dropoff.customApt || '',
                        country: 'US',
                        name: leg.dropoff.customName || '',
                        state: leg.dropoff.customState,
                        zip: leg.dropoff.customZip
                    };

                    itemObjects.push({
                        id: item,
                        properties: {
                            'Builder ID': `${new Date().getTime()}_${c}`,
                            [`${leg.leg_name} Pickup Up Date`]: leg.pickup.date.toLocaleDateString('en-US'),
                            [`${leg.leg_name} Pickup Location Address`]: pickupAddress.address,
                            [`${leg.leg_name} Pickup Location Apt`]: pickupAddress.apt,
                            [`${leg.leg_name} Pickup Location City`]: leg.pickup.customCity,
                            [`${leg.leg_name} Pickup Location Country`]: pickupAddress.country,
                            [`${leg.leg_name} Pickup Location Name`]: pickupAddress.name,
                            [`${leg.leg_name} Pickup Location State`]: pickupAddress.state,
                            [`${leg.leg_name} Pickup Location ZIP`]: pickupAddress.zip,

                            [`${leg.leg_name} Destination Date`]: leg.dropoff.date.toLocaleDateString('en-US'),
                            [`${leg.leg_name} Destination Location Address`]: dropoffAddress.address,
                            [`${leg.leg_name} Destination Location Apt`]: dropoffAddress.apt,
                            [`${leg.leg_name} Destination Location City`]: leg.dropoff.customCity,
                            [`${leg.leg_name} Destination Location Country`]: dropoffAddress.country,
                            [`${leg.leg_name} Destination Location Name`]: dropoffAddress.name,
                            [`${leg.leg_name} Destination Location State`]: dropoffAddress.state,
                            [`${leg.leg_name} Destination Location ZIP`]: dropoffAddress.zip
                        },
                        quantity: this.$store.state.items[item]
                    });
                    c++;
                }
            }

            if (this.$store.state.insuranceID !== "0") {
                itemObjects.push({
                    id: this.$store.state.insuranceID,
                    properties: {
                        'Builder ID': `${new Date().getTime()}_${c++}`,
                        'Insurance': this.$store.state.insurancePrice * 100
                    },
                    quantity: this.$store.state.roundtrip ? 2 : 1
                });
            }

            async function clearCart() {
                try {
                    await axios.post('/cart/clear.js');
                    for (let obj of itemObjects.reverse()) {
                        await axios.post('/cart/add.js', obj);
                    }
                    window.location = "/checkout";
                } catch (err) {
                    console.log('checkout error:', err);
                }
            }

            clearCart();
             } },
    beforeCreate() {
        axios.get('/products/triphero-luggage-new-2018.js')
            .then(response => {
                let variants = response.data.variants.filter(variant => variant.option2 === "Ground");
                this.$store.commit('setUpItems', variants);
            });

        axios.get('/products/value-insurance.js')
            .then(response => {
                let insurance = response.data.variants;
                this.$store.commit('setUpInsurance', insurance);
            })
            .catch(err => {
                console.log(err);
            });
    },
  created() {
        this.prefillAddressFromURL();
    },
 template: `
    <form id="shippingForm" @submit.prevent="submit()" style="padding-top: 100px">

        <div class="luggage">
          <span class="heading span-full">Select Your Luggage and Gear</span>
          <luggage></luggage>
        </div>

        <div class="leg-section">
            <div class="waypoints-container">
                <span class="heading span-full">Enter Your First Leg Details</span>
                <div class="waypoints-inner">
                    <waypoint key="first_leg_pickup" leg="first_leg" waypoint="pickup" subheading="Origin & Pick Up"></waypoint>
                    <waypoint key="first_leg_dropoff" leg="first_leg" waypoint="dropoff" subheading="Destination & Arrival"></waypoint>
                </div>
            </div>
        </div>

        <div class="next-step">
            <div class="button-group">
                <button class="button hollow" @click.prevent="nextScreen('first_leg', true)">I want to make it a round trip</button>
                <button class="button hollow" @click.prevent="nextScreen('checkout', false)">I am just shipping one way</button>
                <a href="https://www.gotriphero.com/contact-ski-and-luggage-shipping" class="button hollow">Need help? Ship with an expert</a>
            </div>
        </div>

        <errors :errors="errors"></errors>

        <div v-if="$store.state.roundtrip">
            <div class="waypoints-container">
                <span class="heading span-full">Enter Your Second Leg Details</span>
                <div class="waypoints-inner">
                    <waypoint key="second_leg_pickup" leg="second_leg" waypoint="pickup" subheading="Origin & Pick Up"></waypoint>
                    <waypoint key="second_leg_dropoff" leg="second_leg" waypoint="dropoff" subheading="Destination & Arrival"></waypoint>
                </div>
            </div>
        </div>

        <div v-if="showCheckout">
            <insurance></insurance>
            <div id="checkoutBox">
              <span class="heading">Your Trip Summary</span>
              <div class="checkout-details">
                <div class="checkout-items">
                  <div>
                    <h4>First Leg</h4>
                    <ul>
                      <li v-for="(q, id) in $store.state.items" :key="'first_' + id" v-if="$store.state.all_items.length">
                        {{ getItemName(id) }} x {{ q }} — \${{ getItemSubtotalByLeg(id, q, 'first_leg') }}
                      </li>
                    </ul>
                  </div>

                  <div v-if="$store.state.roundtrip">
                    <h4>Second Leg</h4>
                    <ul>
                      <li v-for="(q, id) in $store.state.items" :key="'second_' + id" v-if="$store.state.all_items.length">
                        {{ getItemName(id) }} x {{ q }} — \${{ getItemSubtotalByLeg(id, q, 'second_leg') }}
                      </li>
                    </ul>
                  </div>

                   <div>
                    <h4>Insurance</h4>
                    <ul>
                      <li>
                        \${{ $store.state.insuranceValue.toLocaleString('en-US') }} insurance <template v-if="$store.state.roundtrip">each leg</template> - 
                        \${{ ($store.state.insurancePrice * ($store.state.roundtrip ? 2 : 1)).toFixed(2) }}
                      </li>
                    </ul>
                  </div>
                </div>
                <span class="price">Total: \${{ $store.state.totalPrice.toFixed(2) }}</span>
              </div>
              <button type="submit" class="button submit expanded">Ship my bags</button>
            </div>
        </div>

        <div class="spinner-outer" v-show="checkingOut">
            <div class="spinner">
              <div class="bounce1"></div>
              <div class="bounce2"></div>
              <div class="bounce3"></div>
            </div>
        </div>
    </form>
`

});


